import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';

import { DataRepository } from '@core/data/data-repository';
import { PacketApiActions, PacketPageActions } from './packet.actions';

/**
 * Bridges packet actions to the data layer. The effect owns the async load and
 * its error handling so the reducer stays pure.
 */
@Injectable()
export class PacketEffects {
  private readonly actions$ = inject(Actions);
  private readonly repo = inject(DataRepository);

  // On page-enter, fetch the packet reference; dispatch loadSuccess or loadFailure.
  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PacketPageActions.entered),
      switchMap(() =>
        from(this.repo.listPacketReference()).pipe(
          map((reference) => PacketApiActions.loadSuccess({ reference })),
          catchError((err: unknown) =>
            of(PacketApiActions.loadFailure({ error: toMessage(err) })),
          ),
        ),
      ),
    ),
  );
}

/** Normalize any thrown value to a display string for loadFailure. */
function toMessage(err: unknown): string {
  return err instanceof Error ? err.message : 'Unknown error';
}
